import { Caption, useStyles, useTheme } from '@archipro-design/aria';
import * as S from './TradeOnlyTag.style';

const TradeOnlyTag = () => {
    const { css } = useStyles();
    const theme = useTheme();
    return (
        <Caption
            className={css(S.TradeOnlyTag)}
            variant="05"
            variables={{
                captionColor: theme.siteVariables.colors.white['000'],
                fontWeight: 500,
                letterSpacing: '0.05em',
            }}
        >
            Trade only product
        </Caption>
    );
};

export default TradeOnlyTag;
